import { Stack } from "@mui/material";
import React from "react";
import { useComponentSelection } from "../../Hooks/useComponentSelection";
import useObservedText from "../../Hooks/useObservedText";
import useViewOnOpen from "../../Hooks/useViewOnOpen";
import { StackContainerDirection } from "../../Models/StackContainerDirection";
import { StackContainerModel } from "../../Models/StackContainerModel";
import ComponentFactory from "../ComponentFactory";
import IComponentProps from "../IComponentProps";
import getComponentLayout from "../Table/getComponentLayout";

type StackContainerComponentProps = IComponentProps<StackContainerModel>;

const StackContainerComponent: React.FC<StackContainerComponentProps> = ({ component, context, componentPath = [] }) => {
  const spacing = component.Spacing ?? 2;
  const direction = component.Direction === StackContainerDirection.Column ? "column" : "row";

  const componentLayoutSx = getComponentLayout(component);

  useViewOnOpen(component, context, "StackContainerComponent");

  const color = useObservedText(component.Color, context, "StackContainerComponent");
  const backgroundColor = useObservedText(component.BackgroundColor, context, "StackContainerComponent");

  // Enable designer mode selection for this container
  const selectionProps = useComponentSelection({
    component,
    componentPath,
    isContainer: true,
    isEmpty: !component.Children || component.Children.length === 0,
  });

  return (
    <Stack direction={direction} spacing={spacing} sx={{ overflow: "auto", ...componentLayoutSx, color, backgroundColor }} {...selectionProps}>
      {component.Children?.map((child) => (
        <ComponentFactory key={child.Id} parent={component} component={child} context={context} componentPath={[...componentPath, child.Id]} />
      ))}
    </Stack>
  );
};

export default StackContainerComponent;
